import { ICreatorTheme } from "../../../../../features/Common/modules/Theme/theme.interface";
import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    container: {
      display: "flex",
      gap: "10px",
      fontSize: "14px",
    },
    inputContainer: {
      width: "100%",
    },
    textAreaRoot: {
      border: "1px solid #D6D6D6",
      borderRadius: "24px",
      padding: "12px 24px",
      flexGrow: 1,
    },
    textAreaWithAttachmentsRoot: {
      border: "1px solid #D6D6D6",
      borderRadius: "12px 12px 0px 0px",
      padding: "12px 24px",
      flexGrow: 1,
    },
    postCommentBtn: { height: "fit-content", marginTop: "8.5px !important" },
    postCommentBtnIcon: {
      width: "32px !important",
      height: "32px !important",
      cursor: "pointer",
    },
    extras: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
    },
    attachments: {
      display: "flex",
      flexWrap: "wrap",
      padding: "12px 24px",
      backgroundColor: "#F8F8F8",
      gap: "24px",
      border: "1px solid #D6D6D6",
      borderTop: "none",
      borderRadius: "0px 0px 12px 12px",
    },
    imageContainer: {
      position: "relative",
      width: "121px",
      height: "81px",
    },
    newAttachmentPlaceholder: {
      cursor: "pointer",
      marginTop: "6px",
      width: "115px",
      height: "75px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: "1px dashed #A5A5A5",
    },
    image: {
      objectFit: "cover",
      paddingTop: "6px",
      paddingRight: "6x",
      height: "100%",
      width: "100%",
    },
    removeImageButton: {
      position: "absolute",
      top: "0",
      left: "85%",
      zIndex: "1",
      fontSize: "16px",
      backgroundColor: "#1C1B1F !important",
    },
    addIcon: {
      color: "#A5A5A5",
    },
  },
  componentName: "CommentEditor",
});

export const getThemedStyles = ({ theme }: { theme: ICreatorTheme }) => {
  return getStylesObjFromCss({
    styles: {
      postCommentBtnIcon: {
        color: (theme?.colors.color1 || "#493AB1") + " !important",
      },
    },
    componentName: "CommentEditor",
  });
};
